import React from 'react'
import { Head } from '@inertiajs/inertia-react'

const AppHead = ({ title, children }) => {
  return (
    <Head>
      <title>{title ? `${title} - Joseph Prince Ministries (JPM) On Demand` : `Joseph Prince Ministries (JPM) On Demand`}</title>
      {children}
    </Head>
  )
}

export default AppHead
